import React from "react";

export default function Registration(props) {
    return (
        <div>

        </div>
    )
}